import { HttpService } from "../HttpService";
import { URL } from "enum";
const URL_API = URL.RECLUTAMIENTO_Y_SELECCION;

const PreguntasService = {
	async listar() {
		const respuesta = await HttpService(URL_API).get("/preguntas");
		return respuesta.data;
	},
};
export default PreguntasService;
